export var EmailEventPatterns;
(function (EmailEventPatterns) {
    EmailEventPatterns["SEND_EMAIL"] = "SEND_EMAIL";
    EmailEventPatterns["TEST_SEND_EMAIL"] = "TEST_SEND_EMAIL";
    EmailEventPatterns["EMAIL_ERROR"] = "EMAIL_ERROR";
})(EmailEventPatterns || (EmailEventPatterns = {}));
//# sourceMappingURL=email-event-patterns.enum.js.map